import PropTypes from 'prop-types';
import { useLayoutEffect, forwardRef, useState } from 'react';
import { createPortal } from 'react-dom';

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  }

  if (typeof ref === 'object' && ref !== null) {
    ref.current = value;
  }
};

var useBrowserLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : function () {};

var DocumentPortal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;

  var _useState = useState(null),
      node = _useState[0],
      setNode = _useState[1];

  useBrowserLayoutEffect(function () {
    setNode(document.createElement(as));
  }, [as]);
  useBrowserLayoutEffect(function () {
    if (node) {
      document.body.appendChild(node);
      return function () {
        node.parentNode.removeChild(node);
      };
    }
  }, [node]);
  useBrowserLayoutEffect(function () {
    if (ref) {
      updateRef(ref, node);
      return function () {
        updateRef(ref, null);
      };
    }
  }, [node, ref]);
  return node && /*#__PURE__*/createPortal(children, node);
});
DocumentPortal.propTypes
/* remove-proptypes */
= process.env.NODE_ENV !== "production" ? {
  as: PropTypes.string,
  children: PropTypes.node
} : {};

export { DocumentPortal as default };
//# sourceMappingURL=index.esm.js.map
